"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieResponseHeader = exports.getCookieHeader = void 0;
function getCookieHeader() {
    return `cookie`;
}
exports.getCookieHeader = getCookieHeader;
function getCookieResponseHeader() {
    return `set-cookie`;
}
exports.getCookieResponseHeader = getCookieResponseHeader;
